import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: center;
	flex-shrink: 0;
	.motif-icon {
		--size: var(--px-20);
	}
`;
